import { QueryClient } from '@tanstack/react-query';
import React from 'react';
import { Store } from 'redux';

import Home from './_index';

export default (_queryClient: QueryClient, _store: Store) => ({
  path: '/',
  element: <Home />,
  children: [
    {
      path: 'feed',
      lazy: async () => ({ Component: React.lazy(() => import('./feed')) }),
    },
    {
      path: 'gallery',
      lazy: async () => ({ Component: React.lazy(() => import('./gallery')) }),
    },
    {
      path: 'streams',
      lazy: async () => ({ Component: React.lazy(() => import('./streams')) }),
    },
  ],
});
